import React, { FC } from 'react';
import { WithStyle } from '../../utils';
import BoxStyled from './box.styled';
import BoxProps from './types';

const Box: FC<BoxProps> & WithStyle = props => <BoxStyled {...props} />;

Box.defaultProps = {};

Box.displayName = 'Box';
Box.Style = BoxStyled;

export default Box;
